import { render, staticRenderFns } from "./Bankscbonly.vue?vue&type=template&id=aec90c54"
import script from "./Bankscbonly.vue?vue&type=script&lang=js"
export * from "./Bankscbonly.vue?vue&type=script&lang=js"
import style0 from "./Bankscbonly.vue?vue&type=style&index=0&id=aec90c54&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports